import { Button, Modal, Form, Row, Col, Select, Input } from "antd";
import { message } from "antd";
import { useEffect } from "react";
import postDataClaim from "../../../../services/postDataClaim";
import {
  costCenters,
  leaders,
  subCostCenters,
} from "../../../../utils/details";
import { useQuery } from "@tanstack/react-query";
import { handleFetchFirms } from "../../../../api/firms";
import accessLevels from "../../../../utils/accessLevels";

const { Option } = Select;

export default function CreateUser({
  isVisible,
  isLoading,
  setVisible,
  refetch,
}: any) {
  const [form] = Form.useForm();

  const params = `name=${""}`;

  const { data: firms } = useQuery({
    queryKey: ["firms", 1, 40, params],
    queryFn: () =>
      handleFetchFirms({
        page: 1,
        limit: 40,
        params,
      }),
  });
  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    const data = {
      ...values,
    };
    const uri = `claim/claimers/create`;

    const response = await postDataClaim(data, uri);
    if (response.success) {
      message.success("Registed Successfully");
      await refetch();
      form.resetFields();
      setVisible(false);
    } else {
      message.error(response.message);
    }
  };

  const companyOptions = firms?.records?.map((firm: any, index: number) => (
    <Select.Option key={index} value={firm._id}>
      {firm.name}
    </Select.Option>
  ));

  const centerOptions = costCenters.map((item: any, index: number) => (
    <Option value={item?.name} key={index}>
      {item?.name}
    </Option>
  ));

  const subOptions = subCostCenters.map((item: any, index: number) => (
    <Option value={item?.name} key={index}>
      {item?.name}
    </Option>
  ));

  const leaderOptions = leaders.map((item: any, index: number) => (
    <Option value={item?.name} key={index}>
      {item?.name}
    </Option>
  ));

  const accessLevelOptions = accessLevels?.map((level: any, index: number) => (
    <Select.Option key={index} value={level.value}>
      Level: {level.value}
    </Select.Option>
  ));


  useEffect(() => {
    form.resetFields();
  }, []);

  return (
    <Modal
      open={isVisible}
      title="Create Account"
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="AddUser"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="AddUser"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="name"
              label="Full name"
              rules={[
                {
                  required: false,
                  message: "Please enter name",
                },
              ]}
            >
              <Input style={{ width: "100%" }} placeholder="Full name" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="kjlID"
              label="KJL ID"
              rules={[
                {
                  required: false,
                  message: "Please enter KJL ID",
                },
              ]}
            >
              <Input style={{ width: "100%" }} placeholder="KJL ID" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                {
                  required: false,
                  message: "Please enter email",
                },
              ]}
            >
              <Input style={{ width: "100%" }} placeholder="Email" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="mobile"
              label="User Mobile"
              rules={[
                {
                  required: false,
                  message: "Please enter mobile number 1",
                },
              ]}
            >
              <Input style={{ width: "100%" }} placeholder="Mobile number 1" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>

          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="firm"
              label="Current Legal entity"
              rules={[
                {
                  required: false,
                  message: "Please select legal entity",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select legal entity"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {companyOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="costCenter"
              label="Cost center"
              rules={[
                {
                  required: false,
                  message: "Please select cost center",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Cost Center"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {centerOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>

          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="subCostCenter"
              label="Sub cost center"
              rules={[
                {
                  required: false,
                  message: "Please Sub Cost Center",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Sub Cost Centery"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {subOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="businessHead1"
              label="Business segment head (1)"
              rules={[
                {
                  required: false,
                  message: "Please select Business Head 1",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Business Head 1"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {leaderOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>

          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="businessHead2"
              label="Business Segment head (2)"
              rules={[
                {
                  required: false,
                  message: "Please select Business Head 2",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Business Head 2"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {leaderOptions}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="accessLevel"
              label="Access Level"
              rules={[
                {
                  required: false,
                  message: "Please select Access Level",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Access Level"
                optionFilterProp="children"
                style={{ width: "100%" }}
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {accessLevelOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
